import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';

import { FormikForm } from '@/components/formik/FormikForm';
import { FormikSelect } from '@/components/formik/FormikSelect';
import { FormikText } from '@/components/formik/FormikText';
import { InfoBox } from '@/components/InfoBox';

import { TStationFuel } from '@/types/station';

import { stationEditPumpSchema } from '@/validation/station';

import { TAddPumpCommonProps } from '../types';
import { ELECTRIC_TYPE_OPTIONS, FUEL_GRADE_OPTIONS, FUEL_TYPE_OPTIONS } from '../utils';
import { ModalActions } from './ModalActions';

export const EditPumpFormBody = ({ close }: TAddPumpCommonProps) => {
  const { t } = useTranslation();

  const onSubmit = () => {
    // TODO: implement onSubmit
  };

  const { values } = useFormikContext<TStationFuel>();
  return (
    <FormikForm initialValues={values} validationSchema={stationEditPumpSchema} onSubmit={onSubmit}>
      <Grid container>
        <Grid item xs={12}>
          <InfoBox marginBottom={3}>{t('station.newPump.description')}</InfoBox>
        </Grid>
        <Grid item xs={12}>
          <FormikSelect
            name="fuelType"
            label="station.newPump.fuelType"
            options={FUEL_TYPE_OPTIONS}
          />
        </Grid>
        <Grid item xs={12}>
          <FormikSelect
            name="fuelGrade"
            label="station.newPump.grade"
            options={FUEL_GRADE_OPTIONS}
          />
        </Grid>
        <Grid item xs={6}>
          <FormikText name="displayName" label="station.newPump.displayName" type="text" />
        </Grid>
        {values.fuelType === 'ELECTRIC' ? (
          <Grid item xs={6} paddingLeft={2}>
            <FormikSelect
              name="octaneLevel"
              label="station.newPump.rate"
              options={ELECTRIC_TYPE_OPTIONS}
            />
          </Grid>
        ) : (
          <Grid item xs={6} paddingLeft={2}>
            <FormikText name="octaneLevel" label="station.newPump.octane" type="number" />
          </Grid>
        )}
        <Grid item xs={6}>
          <FormikText name="price" label="station.newPump.price" type="number" />
        </Grid>

        <ModalActions close={close} />
      </Grid>
    </FormikForm>
  );
};
